export default __webpack_public_path__ + "static/media/creditStatus.69e5c85a.svg";